import { Component, Input, OnInit } from '@angular/core';
import { AssetApiService } from 'src/app/api/asset/assetApiService';
import { TechnicalDetails } from 'src/app/api/asset/technical-details/technical-details';

@Component({
    selector: 'asset-technical-details',
    templateUrl: './asset-technical-details.component.html',
    styleUrls: ['./asset-technical-details.component.css'],
    host: {'class': 'asset-detail'},
    standalone: false
})
export class AssetTechnicalDetailsComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  loading: boolean = false;
  data: TechnicalDetails | null = null;
  variantDisplayedColumns: string[] = ['code', 'description', 'instruction'];
  electricalDisplayedColumns: string[] = ['printFlag', 'stampFlag', 'voltage', 'frequency', 'connection', 'powerOutput',
   'speed', 'efficiency', 'powerFactor', 'current', 'stallTime', 'torque', 'isIn'];

  constructor(private assetApiService: AssetApiService) { }

  ngOnInit(): void {
    if (this.assetId == undefined) {
      console.log("Empty asset, cannot load technical details");
      return;
    }

    this.loading = true;
    this.assetApiService.getAssetTechnicalDetails(this.assetId)
      .subscribe(x => {
        this.data = x;
        this.loading = false;
      });
  }
}
